import { render } from "./InDetails.vue?vue&type=template&id=1fcc72c7"
import script from "./InDetails.vue?vue&type=script&lang=js"
export * from "./InDetails.vue?vue&type=script&lang=js"

import "./InDetails.vue?vue&type=style&index=0&id=1fcc72c7&lang=scss"

import exportComponent from "C:\\Users\\Alison\\Documents\\Dev\\Apps\\av2-portfolio-v3\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__